/* Original isolated component. Cart writes occur only on an explicit form submission. */
(() => {
  'use strict';
  if (customElements.get('vl-borse-product')) return;
  class VLBorseProduct extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.startTimer);
      this.startTimer = setTimeout(() => { if (this.isConnected) this.initialize(); }, 0);
    }
    initialize() {
      if (this.abort) return;
      this.abort = new AbortController();
      const configNode = this.querySelector('[data-vb-config]');
      try { this.config = JSON.parse(configNode.textContent); }
      catch (error) { console.error('Vittoria Landi: configurazione borse non valida.', error); return; }
      this.form = this.querySelector('[data-vb-form="main"]');
      if (!this.form) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-media-id]'));
      this.sticky = this.querySelector('[data-sticky]');
      this.addButton = this.querySelector('[data-main-add]');
      this.dialog = this.querySelector('[data-zoom-dialog]');
      this.index = 0;
      this.busy = false;
      this.listen(this, 'change', event => {
        if (event.target.matches('[data-sticky-variant]')) {
          const radio = Array.from(this.form.querySelectorAll('[name="id"]')).find(x => x.value === event.target.value);
          if (radio && !radio.disabled) { radio.checked = true; this.updateVariant(true); }
        } else if (event.target.matches('[name="id"]') && this.form.contains(event.target)) {
          this.updateVariant(true);
        }
      });
      this.listen(this, 'click', event => this.onClick(event));
      this.querySelectorAll('[data-vb-form]').forEach(form => this.listen(form, 'submit', event => this.submit(event, form)));
      this.querySelectorAll('[data-js-controls],[data-quantity-step]').forEach(node => { node.hidden = false; });
      if (this.track && this.slides.length) {
        this.listen(this.track, 'scroll', () => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => this.reflectGallery());
        }, { passive: true });
        this.listen(this.track, 'keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
      }
      this.listen(window, 'scroll', () => this.scheduleSticky(), { passive: true });
      this.listen(window, 'resize', () => { this.reflectGallery(); this.scheduleSticky(); }, { passive: true });
      if (this.dialog) {
        this.listen(this.dialog, 'click', event => { if (event.target === this.dialog) this.dialog.close(); });
      }
      this.updateVariant(false);
      this.reflectGallery();
      this.scheduleSticky();
    }
    disconnectedCallback() {
      clearTimeout(this.startTimer);
      this.abort?.abort(); this.abort = null;
      cancelAnimationFrame(this.galleryFrame); cancelAnimationFrame(this.stickyFrame);
    }
    listen(target, name, fn, options = {}) {
      target.addEventListener(name, fn, { ...options, signal: this.abort.signal });
    }
    selectedVariant() {
      const id = this.form.querySelector('[name="id"]:checked')?.value;
      return this.config.variants.find(v => String(v.id) === id);
    }
    updateVariant(updateUrl) {
      const variant = this.selectedVariant();
      if (!variant) return;
      this.querySelector('[data-main-price]').innerHTML = variant.money;
      const compare = this.querySelector('[data-main-compare]');
      const badge = this.querySelector('[data-main-discount]');
      const onSale = Number(variant.compare) > Number(variant.price);
      compare.hidden = !onSale; compare.innerHTML = variant.compareMoney || '';
      badge.hidden = !onSale;
      badge.textContent = onSale ? `-${Math.round((variant.compare - variant.price) * 100 / variant.compare)}%` : '';
      const stickySelect = this.querySelector('[data-sticky-variant]');
      if (stickySelect) stickySelect.value = String(variant.id);
      const stickyPrice = this.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.innerHTML = variant.money;
      this.querySelectorAll('[data-main-add],[data-sticky-add]').forEach(button => {
        button.disabled = !variant.available || this.busy;
        button.textContent = this.busy ? 'AGGIUNTA IN CORSO…' : (variant.available ? 'AGGIUNGI AL CARRELLO' : 'NON DISPONIBILE');
      });
      if (updateUrl) {
        try { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(history.state, '', url); } catch (_) { /* Preview contexts can restrict history. */ }
        if (variant.media) {
          const index = this.slides.findIndex(slide => slide.dataset.mediaId === String(variant.media));
          if (index >= 0) this.goTo(index);
        }
      }
    }
    goTo(index) {
      if (!this.track || !this.slides.length) return;
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      const target = this.slides[index];
      const delta = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left - this.track.clientLeft;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    reflectGallery() {
      if (!this.track || !this.slides.length) return;
      const left = this.track.getBoundingClientRect().left + this.track.clientLeft;
      let best = Infinity;
      this.slides.forEach((slide, index) => { const distance = Math.abs(slide.getBoundingClientRect().left - left); if (distance < best) { best = distance; this.index = index; } });
      const count = this.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      this.querySelectorAll('[data-thumb]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.thumb) === this.index)));
      this.querySelectorAll('[data-gallery-step]').forEach(button => { button.disabled = Number(button.dataset.galleryStep) < 0 ? this.index === 0 : this.index === this.slides.length - 1; });
    }
    scheduleSticky() {
      cancelAnimationFrame(this.stickyFrame);
      this.stickyFrame = requestAnimationFrame(() => {
        if (!this.sticky || !this.addButton) return;
        this.sticky.hidden = this.addButton.getBoundingClientRect().bottom >= 0;
      });
    }
    onClick(event) {
      const button = event.target.closest('button');
      if (button?.hasAttribute('data-thumb')) this.goTo(Number(button.dataset.thumb));
      if (button?.hasAttribute('data-gallery-step')) this.goTo(this.index + Number(button.dataset.galleryStep));
      if (button?.hasAttribute('data-quantity-step')) {
        const input = this.form.querySelector('[name="quantity"]');
        const value = Number.parseInt(input.value, 10) || 1;
        input.value = String(Math.max(1, value + Number(button.dataset.quantityStep)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (button?.hasAttribute('data-close-zoom')) this.dialog?.close();
      const zoom = event.target.closest('[data-zoom]');
      if (zoom && typeof this.dialog?.showModal === 'function') {
        event.preventDefault();
        const image = this.querySelector('[data-zoom-image]');
        image.src = zoom.href; image.alt = zoom.querySelector('img')?.alt || 'Dettaglio della borsa';
        this.dialog.showModal();
      }
      const sizeLink = event.target.closest('[data-size-link]');
      if (sizeLink) {
        const details = this.querySelector(sizeLink.getAttribute('href'));
        if (details) { event.preventDefault(); details.open = true; details.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); details.querySelector('summary')?.focus(); }
      }
    }
    async submit(event, form) {
      if (!window.fetch) return; // Native Shopify form remains the no-JavaScript fallback.
      event.preventDefault(); event.stopPropagation();
      if (this.busy || !form.reportValidity()) return;
      const data = new FormData(form);
      const id = String(data.get('id') || '');
      const quantity = Number(data.get('quantity') || 1);
      const errorBox = form.querySelector('[data-form-error]');
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) {
        if (errorBox) { errorBox.textContent = 'Seleziona una variante e una quantità valida.'; errorBox.hidden = false; }
        return;
      }
      if (errorBox) errorBox.hidden = true;
      this.busy = true;
      const buttons = Array.from(this.querySelectorAll('[data-vb-form] button[type="submit"],[data-sticky-add]'));
      const before = buttons.map(button => [button, button.disabled, button.textContent]);
      buttons.forEach(button => { button.disabled = true; });
      this.updateVariant(false);
      const root = String(this.config.root || '/').replace(/\/?$/, '/');
      try {
        // No automatic retries: a network timeout may follow a successful cart addition.
        const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
        const payload = await response.json();
        if (!response.ok) throw new Error(typeof payload.description === 'string' ? payload.description : 'Questo articolo non può essere aggiunto al carrello. Verifica la disponibilità.');
        window.location.assign(root + 'cart');
      } catch (error) {
        if (errorBox) { errorBox.textContent = error instanceof TypeError ? 'Connessione interrotta. Controlla il carrello prima di riprovare, per evitare duplicati.' : (error.message || 'Non è stato possibile aggiornare il carrello. Riprova.'); errorBox.hidden = false; errorBox.focus(); }
        this.busy = false;
        before.forEach(([button, disabled, text]) => { button.disabled = disabled; button.textContent = text; });
        this.updateVariant(false);
      }
    }
  }
  customElements.define('vl-borse-product', VLBorseProduct);
})();
